import { BlockContent, Image, Seo } from "@components";
import { LanguageContext } from "@contexts";
import AOS from "aos";
import { graphql } from "gatsby";
import React, { useContext, useEffect, useState } from "react";
import { animationEnd, animationStart } from "src/common/lib/svgAnimation/animation-optimized";
import SVGAnimation from "src/common/lib/svgAnimation/svgAnimation";

import * as styles from "./pageStyles/contact.module.scss";
import { Body1, Heading1, Heading2, Heading4 } from "@ui/typography";

const Contact = ({
  data: {
    sanityContact: { title, text, backgroundImage, contactInfo },
  },
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    AOS.init();

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Set initial value
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const { localize } = useContext(LanguageContext);

  return (
    <div className={styles.outerWrapper}>
      <Seo title="Kontakt" />

      <div className={styles.contactSection}>
        <div className={styles.twoColumnFlexContainer}>
          <div className={styles.left}>
          <div
        className={styles.innerWrapper}
        data-aos="fade-left"
        data-aos-duration="1200"
      >
        <Heading1 uppercase fontWeight="fontWeightLight">{localize(title)}</Heading1>
        <div style={{maxWidth: "27rem"}}>
        <BlockContent  blocks={localize(text)} />
        </div>
        <br />
        <br />
        {contactInfo.map((item, index) => (
          <>
          <Body1  fontSize="small" sans key={index}>
            <b style={{fontWeight: 500, textTransform: "uppercase"}}>
            {localize(item.label)}
            </b>
            <br />
            <Body1 fontSize="small" sans>
            <span style={{fontWeight:100, fontFamily: "'Tiempo'"}}>{item.value}</span>
            </Body1>
            </Body1>  
            </>
        ))}
      </div>
          </div>
          <div className={styles.right}>
            <SVGAnimation
              animationStart={animationStart}
              animationEnd={animationEnd}
              minHeight={isMobile ? "30vh" : "60vh"}
              maxHeight={isMobile ? "30vh" : "60vh"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export const query = graphql`
  query {
    sanityContact(_id: { regex: "/contact$/" }) {
      title: _rawTitle
      text: _rawText
      backgroundImage {
        asset {
          gatsbyImageData(fit: FILLMAX, width: 800)
        }
        hotspot {
          y
          x
        }
      }
      contactInfo: _rawContactInfo
    }
  }
`;

export default Contact;
